import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo05: React.createRef(),
    grupo07: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo16: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
    grupo22: React.createRef(),
    grupo23: React.createRef(),
    grupo24: React.createRef(),
    grupo25: React.createRef(),
    grupo27: React.createRef(),

  });

  const [imageStates, setImageStates] = useState({
    grupo05: false,
    grupo07: false,
    grupo13: false,
    grupo14: false,
    grupo16: false,
    grupo17: false,
    grupo18: false,
    grupo20: false,
    grupo21: false,
    grupo22: false,
    grupo23: false,
    grupo24: false,
    grupo25: false,
    grupo27: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes:", statusDasLuzesFlex35);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8300);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo05: statusDasLuzesFlex35.includes("1E10") && !statusDasLuzesFlex35.includes("1E00"),
      grupo07: statusDasLuzesFlex35.includes("1G10") && !statusDasLuzesFlex35.includes("1G00"),
      grupo13: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo14: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo16: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo17: statusDasLuzesFlex35.includes("1Q10") && !statusDasLuzesFlex35.includes("1Q00"),
      grupo18: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo20: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
      grupo21: statusDasLuzesFlex35.includes("1U10") && !statusDasLuzesFlex35.includes("1U00"),
      grupo22: statusDasLuzesFlex35.includes("1V10") && !statusDasLuzesFlex35.includes("1V00"),
      grupo23: statusDasLuzesFlex35.includes("1W10") && !statusDasLuzesFlex35.includes("1W00"),
      grupo24: statusDasLuzesFlex35.includes("1X10") && !statusDasLuzesFlex35.includes("1X00"),
      grupo25: statusDasLuzesFlex35.includes("1Y10") && !statusDasLuzesFlex35.includes("1Y00"),
      grupo27: statusDasLuzesFlex35.includes("1[10") && !statusDasLuzesFlex35.includes("1[00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  
  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return null;
  }

  return (

    <div id="BotoesMobile">
        <h2 id='Title-botoes-Mobile'>Lazer</h2>
        {/* Botões para clicar em cima da legenda */}
        <div className="campoBotoesAcionamentoPage3-mobile">
        <div
          ref={groupRefs.current.grupo05}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo05', !imageStates.grupo05);
            sendCommandFlex35('Varanda Gourmet', imageStates.grupo05 ? '1E00' : '1E10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo05 ? 'Highlighted' : ''}`}>5</p>
          <p className="textBar">Varanda Gourmet</p>
        </div>
        <div
          ref={groupRefs.current.grupo07}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo07', !imageStates.grupo07);
            sendCommandFlex35('SPA', imageStates.grupo07 ? '1G00' : '1G10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo07 ? 'Highlighted' : ''}`}>7</p>
          <p className="textBar">SPA</p>
        </div>
        <div
          ref={groupRefs.current.grupo13}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo13', !imageStates.grupo13);
            sendCommandFlex35('Arandelas', imageStates.grupo13 ? '1M00' : '1M10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo13 ? 'Highlighted' : ''}`}>13</p>
          <p className="textBar">Arandelas</p>
        </div>
        <div
        ref={groupRefs.current.grupo14}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo14', !imageStates.grupo14);
            sendCommandFlex35('Postes lazer', imageStates.grupo14 ? '1N00' : '1N10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo14 ? 'Highlighted' : ''}`}>14</p>
          <p className="textBar">Postes lazer</p>
        </div>
        <div
          ref={groupRefs.current.grupo16}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo16', !imageStates.grupo16);
            sendCommandFlex35('Floreira Degraus', imageStates.grupo16 ? '1P00' : '1P10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo16 ? 'Highlighted' : ''}`}>16</p>
          <p className="textBar">Floreira Degraus</p>
        </div>
        <div
          ref={groupRefs.current.grupo17}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo17', !imageStates.grupo17);
            sendCommandFlex35('Piscina Subaquático', imageStates.grupo17 ? '1Q00' : '1Q10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo17 ? 'Highlighted' : ''}`}>17</p>
          <p className="textBar">Piscina Subaquático</p>
        </div>
        <div
          ref={groupRefs.current.grupo18}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo18', !imageStates.grupo18);
            sendCommandFlex35('Floreira Piscina', imageStates.grupo18 ? '1R00' : '1R10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo18 ? 'Highlighted' : ''}`}>18</p>
          <p className="textBar">Floreira Piscina</p>
        </div>
        <div
        ref={groupRefs.current.grupo20}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo20', !imageStates.grupo20);
            sendCommandFlex35('Arandelas Piscina', imageStates.grupo20 ? '1T00' : '1T10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo20 ? 'Highlighted' : ''}`}>20</p>
          <p className="textBar">Arandelas Piscina</p>
        </div>
        <div
          ref={groupRefs.current.grupo21}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo21', !imageStates.grupo21);
            sendCommandFlex35('Floreiras', imageStates.grupo21 ? '1U00' : '1U10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo21 ? 'Highlighted' : ''}`}>21</p>
          <p className="textBar">Floreiras</p>
        </div>
        <div
          ref={groupRefs.current.grupo22}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo22', !imageStates.grupo22);
            sendCommandFlex35('Quadra de tênis', imageStates.grupo22 ? '1V00' : '1V10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo22 ? 'Highlighted' : ''}`}>22</p>
          <p className="textBar">Quadra de tênis</p>
        </div>
        <div
          ref={groupRefs.current.grupo23}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo23', !imageStates.grupo23);
            sendCommandFlex35('Quadra poliesportiva', imageStates.grupo23 ? '1W00' : '1W10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo23 ? 'Highlighted' : ''}`}>23</p>
          <p className="textBar">Quadra poliesportiva</p>
        </div>
        <div
          ref={groupRefs.current.grupo24}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo24', !imageStates.grupo24);
            sendCommandFlex35('Quadra beach tennis', imageStates.grupo24 ? '1X00' : '1X10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo24 ? 'Highlighted' : ''}`}>24</p>
          <p className="textBar">Quadra beach tennis</p>
        </div>
        <div
          ref={groupRefs.current.grupo25}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo25', !imageStates.grupo25);
            sendCommandFlex35('Tomadas Gourmet', imageStates.grupo25 ? '1Y00' : '1Y10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo25 ? 'Highlighted' : ''}`}>25</p>
          <p className="textBar">Tomadas Gourmet</p>
        </div>
        <div
          ref={groupRefs.current.grupo27}
          className="campoGroup-clickable-element-mobile"
          onClick={() => {handleToggleLightGroup('grupo27', !imageStates.grupo27);
            sendCommandFlex35('Cervejeira Salão de Festas', imageStates.grupo27 ? '1[00' : '1[10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo27 ? 'Highlighted' : ''}`}>27</p>
          <p className="textBar">Cervejeira Salão de Festas</p>
        </div>  
        </div>
    </div>
  );
}

export default BotoesMobile;